import Header from "./Header";
import Footer from "./Footer";
import { useEffect, useState } from "react";
function ContactPage() {
const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",
  message: ""
});
const [responseMsg, setResponseMsg] = useState("");
const [loading, setLoading] = useState(false);

useEffect(() => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "null");

  if (storedUser) {
    setFormData((prev) => ({
      ...prev,
      name: `${storedUser.fname || ""} ${storedUser.lname || ""}`.trim(),
      email: storedUser.email || "",
      phone: storedUser.phone || "",
    }));
  }
}, []);
const handleChange = (e) => {
  const { name, value } = e.target;

  let newValue = value;

  if (name === "phone") {
    newValue = value.replace(/\D/g, "").slice(0, 10);
  }

  if (name === "name") {
    newValue = value.replace(/[^a-zA-Z\s]/g, "");
  }

  setFormData({
    ...formData,
    [name]: newValue,
  });
};
const handleSubmit = async (e) => {
  e.preventDefault();
  setResponseMsg("");

  if (!formData.name.trim()) {
    setResponseMsg("Please enter your name.");
    return;
  }

  if (!formData.email.trim()) {
    setResponseMsg("Please enter your email.");
    return;
  }

  if (!formData.phone.trim()) {
    setResponseMsg("Please enter your phone number.");
    return;
  }

  if (formData.phone.length !== 10) {
    setResponseMsg("Please enter a valid 10 digit phone number.");
    return;
  }

  if (!formData.message.trim()) {
    setResponseMsg("Please enter your message.");
    return;
  }

  try {
    setLoading(true);

    const res = await fetch(
      "https://aethearia.store/superadmin/api/store-contact",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    const data = await res.json();
    console.log("Contact API Response:", data);

    if (data.status) {
      setResponseMsg(data.message || "Message sent successfully.");

     const storedUser = JSON.parse(localStorage.getItem("user") || "null");

setFormData({
  name: storedUser
    ? `${storedUser.fname || ""} ${storedUser.lname || ""}`.trim()
    : "",
  email: storedUser?.email || "",
  phone: storedUser?.phone || "",
  message: "",
});
    } else {
      setResponseMsg(data.message || "Failed to send message.");
    }
  } catch (err) {
    console.error("Contact Error:", err);
    setResponseMsg("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};
return(
<>
<style>{`

.contact-page{
  min-height:100vh;
  padding-top:120px;
  color:#2d241a;
}

/* HERO */
.contact-hero{
  text-align:center;
  padding:40px 20px 20px;
}

.contact-label{
  display:block;
  font-size:11px;
  letter-spacing:4px;
  color:#9f8561;
  margin-bottom:18px;
}

.contact-hero h1{
font-size: 30px;
font-weight: 100;
margin: 20px 0 12px;
color: #4c144e;
   font-family: Assistant, sans-serif;

}

.contact-hero p{
  margin:0 auto;
  max-width:620px;
  line-height:1.9;
  color:#74675a;
  font-size:14px;
}

/* MAIN */
.contact-container{
  max-width:1180px;
  margin:auto;
  padding:0 30px 90px;

  display:grid;
  grid-template-columns:480px 1fr;
  gap:80px;
  align-items:start;
}

/* LEFT IMAGE */
.contact-image{
  position:sticky;
  top:130px;
  overflow:hidden;
}

.contact-image img{
  width:100%;
  height:420px;
  object-fit:cover;
  display:block;
}

/* RIGHT FORM */
.contact-form-wrap{
  padding-top:20px;
}

.contact-heading{
  margin-bottom:40px;
}

.contact-heading h2{
  margin:0 0 14px;
  font-size:35px;
  font-weight:400;
    font-family: Assistant, sans-serif;

}

.contact-heading p{
  margin:0;
  color:#7b6d5d;
  line-height:1.8;
  max-width:520px;
}

/* FORM */
.contact-form{
  width:100%;
}

.contact-row{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:18px;
}

.contact-input,
.contact-textarea{
  width:100%;
  border:1px solid #d8ccbc;
  background:transparent;

  padding:0 18px;
  box-sizing:border-box;
  border-radius:5px;
  font-size:15px;
  color:#2d241a;

  margin-bottom:18px;

  transition:.3s ease;
}

.contact-input{
  height:58px;
}

.contact-textarea{
  height:190px;
  padding-top:18px;
  resize:none;
}

.contact-input:focus,
.contact-textarea:focus{
  outline:none;
  border-color:#9f8561;
  background:#fffdfa;
}

/* BUTTON */
.contact-btn{
  width:140px;
  height:38px;
  border-radius:5px;
  border:none;
  background:#664e64;
  color:#fff;

  font-size:15px;
  cursor:pointer;

  transition:.35s ease;
}

.contact-btn:hover{
  background:#4c144e;
}

/* INFO */
.contact-info{
  margin-top:70px;

  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:30px;

  border-top:1px solid #ddd2c2;
  padding-top:45px;
}

.contact-box span{
  display:block;
  font-size:11px;
  letter-spacing:3px;
  color:#9f8561;
  margin-bottom:14px;
}

.contact-box h4{
  margin:0 0 10px;
  font-size:18px;
  font-weight:500;
}

.contact-box p{
  margin:0;
  color:#756859;
  line-height:1.8;
  font-size:14px;
}

/* MOBILE */
@media(max-width:991px){

  .contact-container{
    grid-template-columns:1fr;
    gap:40px;
  }

  .contact-image{
    position:relative;
    top:0;
  }

  .contact-image img{
    height:500px;
  }

  .contact-info{
    grid-template-columns:1fr;
    gap:35px;
  }

}

@media(max-width:768px){

  .contact-page{
    padding-top:95px;
  }

  .contact-hero{
    padding:20px 18px 45px;
  }

  .contact-hero h1{
    font-size:30px;
  }

  .contact-container{
    padding:0 18px 60px;
  }

  .contact-row{
    grid-template-columns:1fr;
    gap:0;
  }

  .contact-heading h2{
    font-size:32px;
  }

  .contact-image img{
    height:340px;
  }

  .contact-btn{
    width:100%;
  }

}
.contact-response-msg {
  margin-top: 15px;
  color: #4c144e;
  font-size: 14px;
}
`}</style>

      <Header />

      <section className="contact-page">
        <div className="contact-hero">
          {/* <span className="contact-label">CONTACT</span> */}

          <h1>Let’s Connect</h1>

          <p>
            We would love to hear from you. Whether you have a question about
            your order, rituals, gifting or collaborations.
          </p>
        </div>

        <div className="contact-container">
          {/* LEFT IMAGE */}
          <div className="contact-image">
            <img
              src={process.env.PUBLIC_URL + "/banner/contact.jpeg"}
              alt="contact"
            />
          </div>

          {/* FORM */}
          <div className="contact-form-wrap">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-row">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  className="contact-input"
                  value={formData.name}
                  onChange={handleChange}
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  className="contact-input"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              {/* <div className="contact-row"> */}
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  className="contact-input"
                  value={formData.phone}
                  onChange={handleChange}
                  inputMode="numeric"
                  maxLength="10"
                />

                {/* <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  className="contact-input"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div> */}

              <textarea
                name="message"
                placeholder="Write your message..."
                className="contact-textarea"
                value={formData.message}
                onChange={handleChange}
              ></textarea>

             <button type="submit" className="contact-btn" disabled={loading}>
              {loading ? "SENDING..." : "Send Message"}
            </button>
            {responseMsg && (
              <p className="contact-response-msg">
                {responseMsg}
              </p>
            )}
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </>


)
}

export default ContactPage;